import React from 'react';
import BondDocuments from '../../components/shared/BondDocuments';

const AdminBondDocuments = () => {
  return <BondDocuments role="admin" />;
};

export default AdminBondDocuments;
